import Vue from 'vue'
import Vuex from 'vuex'
import { getLocalUser,GetUserSupervisor,GetUserApp,GetUserAppSupervisor } from '../services/auth/authenticate';
import {GetVehicle, GetVehicle_select} from '../services/team/vehicle'
import {GetConductor, GetConductor_select} from '../services/team/driving'
import {GetAsignacion} from '../services/team/asignacion'
import {GetSucursales, GetSucursalesAll} from '../services/options/sucursales'
import {GetEnterprise} from '../services/team/enterprise'
import {GetLista, GetRegistro} from '../services/register/lista'


Vue.use(Vuex)

const user = getLocalUser();

export default new Vuex.Store({
  state: {

    menusingleequipo:false,

    drawer:true,

    currentUser: user,
    isLoggedIn: !!user,
    loading: false,
    auth_error: null,
    menu_registro: false,
    loading_charge:false,

    ///
    users_supervisor:[],
    users_app:[],
    //

    ////API

    loading_dashboard:false,
    vehicle:[],
    conductor:[],
    asignacion:[],
    lista:[],
    fecha_filter:[],
    RegistroLista:[],

    
    asignacion_single_select:{},
    select_table:[],




    select:{

      driving:[],
      vehicle:[]

    },

    items_selected_register:[],
    loadingFetch:false,

    ////

    
    ///config
    sucursal:[],
    sucursalAll:[],
    Enterprise:[],
    ///

    selected_create_register:[],
    vehiculo_notiene_asignacion:false,

    vm:'',
    vp:'',
    ci:'',
    cn:'',
    changeConductorSwith:false,
    select_edit_vehiculo:'',

  },

  getters: {
    
    vm: (state) => {
      return state.vm;
    },
    vp: (state) => {
      return state.vp;
    },
    ci: (state) => {
      return state.ci;
    },
    cn: (state) => {
      return state.cn;
    },

    
    select_asignacion_getters: state => {
      var array = new Array;
      var items = state.select.vehicle;
      for (let e = 0; e < items.length; e++) {
         array.push({ 'id':items[e].id, 'name':items[e].name+' - '+items[e].enrollment});
      }
      return array;
    },


    select_empresa_edit_vehiculo: state => id => {
      var respuesta = state.Enterprise.find(todo => todo.id == id);
      return respuesta.Nombre;
    },

    select_responsable_app: state  => {
      var array = new Array;
      var items = state.users_supervisor;

      for (let i = 0; i < items.length; i++) {
        array.push(items[i].name);
      }
      return array;
    },

    select_registro_pdf: state  => {
      var array = new Array;
      var items = state.items_selected_register;

      for (let i = 0; i < items.length; i++) {
        array.push(items[i].id);
      }
      return array.toString();
    },

    select_registro_filter: state  => {
      var items = state.fecha_filter;
      return JSON.stringify(items);
    },

    asignacionConductor: state  => {
      var array = new Array;
      
      if (state.cn != '') {
        array.push('Otro conductor');  
      }
      for (let i = 0; i < state.asignacion.length; i++) {
        array.push(state.asignacion[i].conductor);
      }
      return array;
    },

    asignacionConductorfull: state  => {
      var array = new Array;
      
      if (state.cn != '' ) {
        array.push('Otro conductor');  
      }
      for (let i = 0; i < state.conductor.length; i++) {
        array.push(state.conductor[i].name);
      }
      return array;
    },

    

    asignacionVehiculo: state  => {
      var array = new Array;
      for (let i = 0; i < state.asignacion.length; i++) {
        array.push(state.asignacion[i].asignacion);
      }
      return array;
    },
    /////////////////////////FULLL VEHICULO
    asignacionVehiculofull: state  => {
      var array = new Array;
      for (let i = 0; i < state.vehicle.length; i++) {
        array.push(state.vehicle[i].name);
      }
      return array;
    },
    asignacionIdentificacionfull: state  => {
      var array = new Array;
      for (let i = 0; i < state.vehicle.length; i++) {
        array.push(state.vehicle[i].enrollment);
      }
      return array;
    },



    ////////////////////////////////////
    asignacionDNI: state  => {
      var array = new Array;
      for (let i = 0; i < state.asignacion.length; i++) {
        array.push(state.asignacion[i].DNI);
      }
      return array;
    },

    asignacionDNIfull: state  => {
      var array = new Array;
      for (let i = 0; i < state.conductor.length; i++) {
        array.push(state.conductor[i].dni);
      }
      return array;
    },

    asignacionIdentificacion: state  => {
      var array = new Array;
      for (let i = 0; i < state.asignacion.length; i++) {
        array.push(state.asignacion[i].matricula);
      }
      return array;
    },


    obtenerEmpresas: state => {

      var array = new Array;
      array.push('Todas');
      for (let i = 0; i < state.Enterprise.length; i++) {
        array.push(state.Enterprise[i].Nombre);
      }
      return array;

    },
    
    obtenerSucursales: state => {

      var array = new Array;
      array.push('Todas');
      for (let i = 0; i < state.sucursal.length; i++) {
        array.push(state.sucursal[i][0]);
      }
      return array;

    }

  },

  mutations: {
    
    mutation_users_supervisor(state, payload){

      state.users_supervisor = payload

    },

    mutation_users_app(state,payload){
      state.users_app = payload
    },

    mutation_filterRegisterCreateChange(state, payload) {

      var selected = state.conductor.find(todo => todo.name == payload);

      state.ci = selected.dni;
      state.cn = selected.name;

      state.changeConductorSwith = true;
    },

    mutation_switch_change_driving(state, payload){
      state.ci = '';
      state.cn = '';

      state.changeConductorSwith = payload;
    },


    mutation_FetchActions(state, payload){
      state.loadingFetch = payload;
    },

    mutation_menusingleequipo(state, payload){
      state.menusingleequipo = payload;
    },

    mutation_filterRegisterCreate(state, payload){

      if (payload.type == 'vp') {
        //console.log(payload.type);
        state.selected_create_register = state.asignacion.find(todo => todo.matricula == payload.item);
        if (state.selected_create_register) {
          state.vm = state.selected_create_register.asignacion;
          state.vp = state.selected_create_register.matricula;
          state.ci = state.selected_create_register.DNI;
          state.cn = state.selected_create_register.conductor;
        }else{
          state.selected_create_register = state.vehicle.find(todo => todo.enrollment == payload.item);
          if (state.selected_create_register) {
            state.vm = state.selected_create_register.name;
            state.vp = state.selected_create_register.enrollment;
            state.ci = [];
            state.cn = [];
            state.vehiculo_notiene_asignacion = true;
          }
        }
        
            
        

      }

      if (payload.type == 'vm') {
        //console.log(payload.type);
        state.selected_create_register = state.asignacion.find(todo => todo.asignacion == payload.item);
        if (state.selected_create_register) {
          state.vm = state.selected_create_register.asignacion;
          state.vp = state.selected_create_register.matricula;
          state.ci = state.selected_create_register.DNI;
          state.cn = state.selected_create_register.conductor;  
        }else{
          state.selected_create_register = state.vehicle.find(todo => todo.name == payload.item);
          if (state.selected_create_register) {
            state.vm = state.selected_create_register.name;
            state.vp = state.selected_create_register.enrollment;
            state.ci = [];
            state.cn = [];
            state.vehiculo_notiene_asignacion = true;
          }
        }
        
        
      }

      if (payload.type == 'cn') {
        //console.log(payload.type);
        if (payload.item == 'Otro conductor') {
          state.ci = '';
          state.cn = '';  
        }else{
          state.selected_create_register = state.asignacion.find(todo => todo.conductor == payload.item);
          if (state.selected_create_register) {
            state.vm = state.selected_create_register.asignacion;
            state.vp = state.selected_create_register.matricula;
            state.ci = state.selected_create_register.DNI;
            state.cn = state.selected_create_register.conductor;  
          }else{
            state.selected_create_register = state.conductor.find(todo=>todo.name == payload.item);
            state.cn = state.selected_create_register.name;
            state.ci = state.selected_create_register.dni;
          }
           
          
        }
      }

      if (payload.type == 'ci') {
        //console.log(payload.type);
        state.selected_create_register = state.asignacion.find(todo => todo.DNI == payload.item);
        state.vm = state.selected_create_register.asignacion;
        state.vp = state.selected_create_register.matricula;
        state.ci = state.selected_create_register.DNI;
        state.cn = state.selected_create_register.conductor;
      }

    },

    mutation_filterRegisterDelete(state){
        state.vm = ''
        state.vp = ''
        state.ci = ''
        state.cn = ''
    },

    deleteregistro_commit(state){
      state.select_registro_pdf = [];
      state.items_selected_register = [];
    },

    mutation_fecha_filter(state, payload){
      state.fecha_filter = payload;
    },

    mutation_menu_registro(state,payload){
      state.menu_registro = payload;
    },

    mutation_selected_register_report(state,payload){

      state.items_selected_register = payload;

    },

    mutation_select_table(state, payload){
      state.select_table = payload;
    },

    mutation_RegistroLista(state, payload){
      state.RegistroLista = payload;
    },

    mutation_vehicle(state, payload){
      state.vehicle = payload
    },

    mutation_Emterprise(state,payload){
      state.Enterprise = payload;
    },

    mutation_driving(state, payload){
      state.conductor = payload;
    },

    mutation_lista(state, payload){
      state.lista = payload;
    },

    mutation_asignacion(state, payload){
      state.asignacion = payload;
    },

    mutation_loading_charge(state, item){
      state.loading_charge = item;
    },

    mutation_select(state, payload){
      if (payload.type == 'conductor') {
        state.select.driving = payload.data;
      }else{
        state.select.vehicle = payload.data;
      }
    },

    mutation_loading_dashboard(state, payload){
      state.loading_dashboard = payload;
    },

    mutation_sucursal(state, payload){
      state.sucursal = payload;
    },

    mutation_sucursalesAll(state, Payload){
      state.sucursalAll = Payload;
    },
    
    
    SelectGeneraltMutation(state,payload){
      if (payload.type == 'edit_vehiculo') {
        state.select_edit_vehiculo = payload.data;
      }
    },

    SelectGetGeneraltMutation(state,payload){
      if (payload.type == 'edit_vehiculo') {
        state.select_edit_vehiculo = payload.data;
      }
    },
    ////
    
    
    isLoading(state) {
      return state.loading;
    },
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    currentUser(state) {
      return state.currentUser;
    },
    authError(state) {
      return state.auth_error;
    },
    customers(state) {
      return state.auth_error;
    },

    mutation_drawer(state){
      state.drawer = !state.drawer;
    },


    login(state) {
      state.loading = true;
      state.auth_error = null;
    },

    loading_mutation(state){
      state.loading = !state.loading
    },

    loginSuccess(state, payload) {
      state.auth_error = null;
      state.isLoggedIn = true;
      state.loading = false;
      state.currentUser = Object.assign({}, payload, {
        token: payload
      });

      localStorage.setItem("user", JSON.stringify(state.currentUser));
    },

    

    loginFailed(state, payload) {
      state.loading = false;
      state.auth_error = payload.error;
    },

    logout(state) {
      localStorage.removeItem("user");
      state.isLoggedIn = false;
      state.currentUser = null;
    }


  },
  actions: {

    deleteregistro({commit}){
      commit('deleteregistro_commit');
    },

    MenuAction({commit}){
      commit('mutation_drawer');
    },

    LoadingAction({commit}){
      commit('mutation_loading_dashboard', true);
    },

    GetVehicles({commit}){
      commit('mutation_loading_charge', true);
      GetVehicle().then(response=>{
        //console.log(response);
          commit('mutation_vehicle', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
        }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetDrivings({commit}){
      commit('mutation_loading_charge',true);
      GetConductor().then(response=>{
        //console.log(response);
          commit('mutation_driving', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge',false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge' ,false);
      });
    },

    GetAsign({commit}){
      commit('mutation_loading_charge',true);
      GetAsignacion().then(response=>{
        //console.log(response);
          commit('mutation_asignacion', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge',false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetSucursal({commit}){
      commit('mutation_loading_charge', true);
      GetSucursales().then(response=>{
        //console.log(response);
          commit('mutation_sucursal', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetSucursalAll({commit}){
      commit('mutation_loading_charge', true);
      GetSucursalesAll().then(response=>{
        //console.log(response);
          commit('mutation_sucursalesAll', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },


    GetListas({commit}){
      commit('mutation_loading_charge', true);
      GetLista().then(response=>{
        //console.log(response);
          commit('mutation_lista', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetRegListas({commit}, item){
      commit('mutation_loading_charge', true);
      GetRegistro(item.inicio, item.final, item.empresa, item.localidad).then(response=>{
        //console.log(response);
          commit('mutation_RegistroLista', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetEmpresas({commit}){
      commit('mutation_loading_charge',true);
      GetEnterprise().then(response=>{
        //console.log(response);
          commit('mutation_Emterprise', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetUserSupervisorActions({commit}){
      commit('mutation_loading_charge',true);
      GetUserSupervisor().then(response=>{
        //console.log(response);
          commit('mutation_users_supervisor', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },
    
    
    GetUserAppsActions({commit}, id){
      commit('mutation_loading_charge',true);
      GetUserAppSupervisor(id).then(response=>{
        //console.log(response);
          commit('mutation_users_app', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    GetUserAppActions({commit}){
      commit('mutation_loading_charge',true);
      GetUserApp().then(response=>{
        //console.log(response);
          commit('mutation_users_app', response)
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
    },

    

    


    GetAllSelect({commit}){
      commit('mutation_loading_charge', true);
      GetVehicle_select().then(response=>{
        
        //console.log(response);
          commit('mutation_select', {type:'vehiculo', data:response})
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
        commit('mutation_loading_charge', false);
      });
      GetConductor_select().then(response=>{
        //commit('mutation_loading_charge', true);
        //console.log(response);
         commit('mutation_loading_charge', false);
          commit('mutation_select', {type:'conductor', data:response})
          commit('mutation_loading_dashboard', false);
      }).catch(errors=>{
        console.log(errors);
        commit('mutation_loading_dashboard', false);
      //  commit('mutation_loading_charge', false);
      });
      
    },


    selectTableAction({commit}, response){
      commit('mutation_select_table', response);
    },


    ActionSelectRegisterPdf({commit}, response){
      commit('mutation_selected_register_report', response);
    },

    filtertable({commit, state, getters}, {type, item}){
      commit('mutation_loading_dashboard', true);
      commit('mutation_loading_charge',true);
      commit('mutation_RegistroLista', []);
      if (type == 'Fecha') {

        //console.log(item);

        commit('mutation_fecha_filter', item);
        GetRegistro(item.inicio, item.final, item.empresa, item.localidad).then(response=>{
          //console.log(response);
            commit('mutation_RegistroLista', response);
            commit('mutation_loading_dashboard', false);
            commit('mutation_loading_charge', false);
        }).catch(errors=>{
          console.log(errors);
          commit('mutation_loading_dashboard', false);
          commit('mutation_loading_charge', false);
        });
        
      }

    },

    asidebarRegistro({commit}, item){

      commit('mutation_menu_registro', item);

    },

    
    filterRegisterCreate({commit}, item){
      commit('mutation_filterRegisterCreate', item);
    },

    filterRegisterDelete({commit}){
      commit('mutation_filterRegisterDelete');
    },
    
    filterRegisterCreateChange({commit}, item) {
      commit('mutation_filterRegisterCreateChange', item)
    },


    MenuEquipo({commit}, item){
      commit('mutation_menusingleequipo', item);
    },

    LoadingFetchActions({commit}, item){
      commit('mutation_FetchActions', item);
    },

    SelectGeneraltActions({commit}, item){
      commit('SelectGeneraltMutation', item);
    },

    SelectGetGeneraltActions({commit}, item){
      commit('SelectGetGeneraltMutation', item);
    },


    action_switch_change_driving({commit}, item){
      commit('mutation_switch_change_driving', item);
    }


  },
  
  modules: {
  }
})
